import { FeatureToggleKey } from "@omni/types/enums/featureToggleKey.enum";

import { WindowEvent } from "../windowEvent.service";

type FeatureToggleChangeEventDetail = {
    key: FeatureToggleKey;
    enabled: boolean;
};

export class FeatureToggleChangeEvent extends CustomEvent<FeatureToggleChangeEventDetail> {
    constructor(key: FeatureToggleKey, enabled: boolean) {
        super(WindowEvent.FeatureToggleChange, {
            detail: {
                key: key,
                enabled: enabled
            }
        });
    }
}
